import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiConfiguration } from '../api-configuration';
import {
  HomologousConsumptionResponse,
  SearchStatsModel,
  SearchStatsResponseModel,
  StatisticsViewModel,
  PaginatedDetailedConsumptionRequest,
  PaginatedDetailedConsumptionResponse,
} from '../models/statistics';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class StatisticsService {
  route = new ApiConfiguration();
  ApiGetStatsViewModelPath =
    this.route.rootUrl + '/api/Estatisticas/get-stats-view-model';
  ApiSearchStatsPath = this.route.rootUrl + '/api/Estatisticas/search-stats';
  ApiPaginatedDetailedConsumptionPath = this.route.rootUrl + '/api/Estatisticas/get-paginated-detailed-consumption';
  ApiHomologousConsumptionPath = this.route.rootUrl + '/api/Estatisticas/get-homologous-consumption';

  constructor(private http: HttpClient, private authService: AuthService) { }

  GetStatisticsViewModel(clientId: string, subClientId: string = ''): Observable<StatisticsViewModel> {

    const endpoint = `${this.ApiGetStatsViewModelPath}/${clientId}`;
    const accessToken = localStorage.getItem('BIO2_AccessToken');

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + accessToken,
    });

    let params = new HttpParams();

    if (subClientId) {
      params = params.set('subClientId', subClientId);
    }

    return this.http.get<StatisticsViewModel>(endpoint, {
      headers,
      params,
    });
  }

  SearchStats(
    searchParameters: SearchStatsModel
  ): Observable<SearchStatsResponseModel> {
    const endpoint = `${this.ApiSearchStatsPath}`;
    const accessToken = localStorage.getItem('BIO2_AccessToken');
    const tokenData = this.authService.getDecodedAccessToken(accessToken!);

    searchParameters.userId = tokenData['registoId'];

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    });

    return this.http.post<SearchStatsResponseModel>(endpoint, searchParameters, {
      headers,
    });
  }

  GetPaginatedDetailedConsumption(
    request: PaginatedDetailedConsumptionRequest
  ): Observable<PaginatedDetailedConsumptionResponse> {
    const accessToken = localStorage.getItem('BIO2_AccessToken');
    const tokenData = this.authService.getDecodedAccessToken(accessToken!);
    request.userId = tokenData['registoId'];

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    });

    return this.http.post<PaginatedDetailedConsumptionResponse>(
      this.ApiPaginatedDetailedConsumptionPath,
      request,
      { headers }
    );
  }

  /**
   * Monthly consumption for the homologous period (N-1 / N-2) of a search.
   * Takes the same payload as SearchStats plus `homologousPeriod`.
   */
  GetHomologousConsumption(
    searchParameters: SearchStatsModel
  ): Observable<HomologousConsumptionResponse> {
    const accessToken = localStorage.getItem('BIO2_AccessToken');
    const tokenData = this.authService.getDecodedAccessToken(accessToken!);
    searchParameters.userId = tokenData['registoId'];

    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    });

    return this.http.post<HomologousConsumptionResponse>(
      this.ApiHomologousConsumptionPath,
      searchParameters,
      { headers }
    );
  }
}
